import { useSyncExternalStore } from 'react';
import { RemoteStatus, remoteStore } from '../init/registerStore';
export function useAreModulesReady() {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const remotes = useSyncExternalStore(remoteStore.subscribe, remoteStore.getSnapshot);
    const isReady = Object.values(remotes).length > 0 &&
        Object.values(remotes).every(item => item.entries.register !== RemoteStatus.initializing);
    return isReady;
}
